var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewRoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1711_539)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1711_539",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1711_539)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.4 26.9335C5.74 26.9335 5.175 26.6985 4.705 26.2285C4.235 25.7585 4 25.1935 4 24.5335V7.7335C4 7.0735 4.235 6.5085 4.705 6.0385C5.175 5.5685 5.74 5.3335 6.4 5.3335H13.6C14.26 5.3335 14.825 5.5685 15.295 6.0385C15.765 6.5085 16 7.0735 16 7.7335V10.1335H25.6C26.26 10.1335 26.825 10.3685 27.295 10.8385C27.765 11.3085 28 11.8735 28 12.5335V24.5335C28 25.1935 27.765 25.7585 27.295 26.2285C26.825 26.6985 26.26 26.9335 25.6 26.9335H6.4ZM6.4 24.5335H13.6V22.1335H6.4V24.5335ZM6.4 19.7335H13.6V17.3335H6.4V19.7335ZM6.4 14.9335H13.6V12.5335H6.4V14.9335ZM6.4 10.1335H13.6V7.7335H6.4V10.1335ZM16 24.5335H25.6V12.5335H16V24.5335ZM19.6 17.3335C19.26 17.3335 18.975 17.2185 18.745 16.9885C18.515 16.7585 18.4 16.4735 18.4 16.1335C18.4 15.7935 18.515 15.5085 18.745 15.2785C18.975 15.0485 19.26 14.9335 19.6 14.9335H22C22.34 14.9335 22.625 15.0485 22.855 15.2785C23.085 15.5085 23.2 15.7935 23.2 16.1335C23.2 16.4735 23.085 16.7585 22.855 16.9885C22.625 17.2185 22.34 17.3335 22 17.3335H19.6ZM19.6 22.1335C19.26 22.1335 18.975 22.0185 18.745 21.7885C18.515 21.5585 18.4 21.2735 18.4 20.9335C18.4 20.5935 18.515 20.3085 18.745 20.0785C18.975 19.8485 19.26 19.7335 19.6 19.7335H22C22.34 19.7335 22.625 19.8485 22.855 20.0785C23.085 20.3085 23.2 20.5935 23.2 20.9335C23.2 21.2735 23.085 21.5585 22.855 21.7885C22.625 22.0185 22.34 22.1335 22 22.1335H19.6Z",
    fill: "#fff"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1711_539"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewRoom);
export default __webpack_public_path__ + "static/media/newRoom.a45fd860c903d9552dbf5266981cd82c.svg";
export { ForwardRef as ReactComponent };